// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "-" + {"149":"c754b1d3b4ce6336b5c5","710":"ec0e7bd03004a8b2d65a"}[chunkId] + ".js";
};